module.exports = __webpack_public_path__ + "img/recentes-vendas.26b46996.svg";